"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExchangeRateMap = exports.PACKAGES = exports.TIER = exports.PACKAGENAMES = exports.MANIFEST_PACKAGENAMES = void 0;
const GLOBAL_FREE_TRIAL_DAYS = 14;
const GLOBAL_FREE_TRIAL_DAYS_V2 = 7;
var MANIFEST_PACKAGENAMES;
(function (MANIFEST_PACKAGENAMES) {
    MANIFEST_PACKAGENAMES["FREE"] = "FREE";
    MANIFEST_PACKAGENAMES["GLOBAL_STARTER_1_MONTH"] = "GLOBAL_STARTER_1_MONTH";
    MANIFEST_PACKAGENAMES["GLOBAL_BOOST_1_MONTH"] = "GLOBAL_BOOST_1_MONTH";
    MANIFEST_PACKAGENAMES["GLOBAL_GROWTH_1_MONTH"] = "GLOBAL_GROWTH_1_MONTH";
    MANIFEST_PACKAGENAMES["GLOBAL_SCALE_1_MONTH"] = "GLOBAL_SCALE_1_MONTH";
    MANIFEST_PACKAGENAMES["GLOBAL_STARTER_12_MONTH"] = "GLOBAL_STARTER_12_MONTH";
    MANIFEST_PACKAGENAMES["GLOBAL_BOOST_12_MONTH"] = "GLOBAL_BOOST_12_MONTH";
    MANIFEST_PACKAGENAMES["GLOBAL_GROWTH_12_MONTH"] = "GLOBAL_GROWTH_12_MONTH";
    MANIFEST_PACKAGENAMES["GLOBAL_SCALE_12_MONTH"] = "GLOBAL_SCALE_12_MONTH";
    // new plan structure for manifest
    MANIFEST_PACKAGENAMES["GLOBAL_BASIC_1_MONTH"] = "GLOBAL_BASIC_1_MONTH";
    MANIFEST_PACKAGENAMES["GLOBAL_PREMIUM_1_MONTH"] = "GLOBAL_PREMIUM_1_MONTH";
    MANIFEST_PACKAGENAMES["GLOBAL_VIP_1_MONTH"] = "GLOBAL_VIP_1_MONTH";
    MANIFEST_PACKAGENAMES["GLOBAL_ENTERPRISE_1_MONTH"] = "GLOBAL_ENTERPRISE_1_MONTH";
    MANIFEST_PACKAGENAMES["GLOBAL_BASIC_12_MONTH"] = "GLOBAL_BASIC_12_MONTH";
    MANIFEST_PACKAGENAMES["GLOBAL_PREMIUM_12_MONTH"] = "GLOBAL_PREMIUM_12_MONTH";
    MANIFEST_PACKAGENAMES["GLOBAL_VIP_12_MONTH"] = "GLOBAL_VIP_12_MONTH";
    MANIFEST_PACKAGENAMES["GLOBAL_ENTERPRISE_12_MONTH"] = "GLOBAL_ENTERPRISE_12_MONTH";
})(MANIFEST_PACKAGENAMES = exports.MANIFEST_PACKAGENAMES || (exports.MANIFEST_PACKAGENAMES = {}));
var PACKAGENAMES;
(function (PACKAGENAMES) {
    PACKAGENAMES["BIK_INSTAGRAM_PLAN"] = "BIK_INSTAGRAM_PLAN";
    PACKAGENAMES["BIK_GROWTH_PLAN"] = "BIK_GROWTH_PLAN";
    PACKAGENAMES["BIK_BUSINESS_PLAN"] = "BIK_BUSINESS_PLAN";
    PACKAGENAMES["BIK_CUSTOM_PLAN"] = "BIK_CUSTOM_PLAN";
    PACKAGENAMES["BIK_FREE_PLAN"] = "BIK_FREE_PLAN";
    PACKAGENAMES["BIK_PLG_GROWTH_PLAN"] = "BIK_PLG_GROWTH_PLAN";
    PACKAGENAMES["BIK_PLG_BUSINESS_PLAN"] = "BIK_PLG_BUSINESS_PLAN";
    PACKAGENAMES["BIK_PLG_STARTER_PLAN"] = "BIK_PLG_STARTER_PLAN";
    PACKAGENAMES["BIK_SALES_STARTER_PLAN"] = "BIK_SALES_STARTER_PLAN";
    PACKAGENAMES["BIK_SALES_GROWTH_PLAN"] = "BIK_SALES_GROWTH_PLAN";
    PACKAGENAMES["BIK_SALES_BUSINESS_PLAN"] = "BIK_SALES_BUSINESS_PLAN";
})(PACKAGENAMES = exports.PACKAGENAMES || (exports.PACKAGENAMES = {}));
var TIER;
(function (TIER) {
    TIER["TIER_0"] = "TIER_0";
    TIER["TIER_1"] = "TIER_1";
    TIER["TIER_2"] = "TIER_2";
    TIER["TIER_3"] = "TIER_3";
    TIER["TIER_4"] = "TIER_4";
    TIER["TIER_5"] = "TIER_5";
    TIER["TIER_6"] = "TIER_6";
})(TIER = exports.TIER || (exports.TIER = {}));
exports.PACKAGES = {
    FREE: {
        packageName: 'FREE',
        quota: 100,
        duration: 30,
        description: 'Free plan',
        price: 0,
        freeTrialDays: 0,
        overagePrice: 0,
        overageAllowed: 0,
    },
    GLOBAL_STARTER_1_MONTH: {
        packageName: 'GLOBAL_STARTER_1_MONTH',
        quota: 1000,
        duration: 30,
        description: 'Bik Starter Monthly Package',
        price: 39,
        freeTrialDays: GLOBAL_FREE_TRIAL_DAYS,
        overagePrice: 0.04,
        overageAllowed: 4975,
    },
    GLOBAL_BOOST_1_MONTH: {
        packageName: 'GLOBAL_BOOST_1_MONTH',
        quota: 3000,
        duration: 30,
        description: 'Bik Boost Monthly Package',
        price: 99,
        freeTrialDays: GLOBAL_FREE_TRIAL_DAYS,
        overagePrice: 0.04,
        overageAllowed: 4975,
    },
    GLOBAL_GROWTH_1_MONTH: {
        packageName: 'GLOBAL_GROWTH_1_MONTH',
        quota: 7500,
        duration: 30,
        description: 'Bik Growth Monthly Package',
        price: 249,
        freeTrialDays: GLOBAL_FREE_TRIAL_DAYS,
        overagePrice: 0.035,
        overageAllowed: 14229,
    },
    GLOBAL_SCALE_1_MONTH: {
        packageName: 'GLOBAL_SCALE_1_MONTH',
        quota: 30000,
        duration: 30,
        description: 'Bik Scale Monthly Package',
        price: 799,
        freeTrialDays: GLOBAL_FREE_TRIAL_DAYS,
        overagePrice: 0.025,
        overageAllowed: 63920,
    },
    GLOBAL_STARTER_12_MONTH: {
        packageName: 'GLOBAL_STARTER_12_MONTH',
        quota: 1000 * 12,
        duration: 365,
        description: 'Bik Starter Annual Package',
        price: 399,
        freeTrialDays: GLOBAL_FREE_TRIAL_DAYS,
    },
    GLOBAL_BOOST_12_MONTH: {
        packageName: 'GLOBAL_BOOST_12_MONTH',
        quota: 3000 * 12,
        duration: 365,
        description: 'Bik Boost Annual Package',
        price: 999,
        freeTrialDays: GLOBAL_FREE_TRIAL_DAYS,
    },
    GLOBAL_GROWTH_12_MONTH: {
        packageName: 'GLOBAL_GROWTH_12_MONTH',
        quota: 7500 * 12,
        duration: 365,
        description: 'Bik Growth Annual Package',
        price: 2499,
        freeTrialDays: GLOBAL_FREE_TRIAL_DAYS,
    },
    GLOBAL_SCALE_12_MONTH: {
        packageName: 'GLOBAL_SCALE_12_MONTH',
        quota: 30000 * 12,
        duration: 365,
        description: 'Bik Scale Annual Package',
        price: 7999,
        freeTrialDays: GLOBAL_FREE_TRIAL_DAYS,
    },
    // details for new plan structure for manifest
    GLOBAL_BASIC_1_MONTH: {
        packageName: 'GLOBAL_BASIC_1_MONTH',
        quota: 600,
        duration: 30,
        description: 'Bik Basic Monthly Package',
        price: 99,
        freeTrialDays: GLOBAL_FREE_TRIAL_DAYS_V2,
        overagePrice: 0.20,
        overageAllowed: 1500,
    },
    GLOBAL_PREMIUM_1_MONTH: {
        packageName: 'GLOBAL_PREMIUM_1_MONTH',
        quota: 2500,
        duration: 30,
        description: 'Bik Premium Monthly Package',
        price: 249,
        freeTrialDays: GLOBAL_FREE_TRIAL_DAYS_V2,
        overagePrice: 0.15,
        overageAllowed: 5000,
    },
    GLOBAL_VIP_1_MONTH: {
        packageName: 'GLOBAL_VIP_1_MONTH',
        quota: 7000,
        duration: 30,
        description: 'Bik VIP Monthly Package',
        price: 499,
        freeTrialDays: GLOBAL_FREE_TRIAL_DAYS_V2,
        overagePrice: 0.10,
        overageAllowed: 15000,
    },
    GLOBAL_ENTERPRISE_1_MONTH: {
        packageName: 'GLOBAL_ENTERPRISE_1_MONTH',
        quota: 7000,
        duration: 30,
        description: 'Manifest Enterprise Monthly Package',
        price: 499,
        overagePrice: 0.10,
        overageAllowed: 15000,
        freeTrialDays: GLOBAL_FREE_TRIAL_DAYS_V2,
    },
    GLOBAL_BASIC_12_MONTH: {
        packageName: 'GLOBAL_BASIC_12_MONTH',
        quota: 600 * 12,
        duration: 365,
        description: 'Bik Basic Annual Package',
        price: 999,
        freeTrialDays: GLOBAL_FREE_TRIAL_DAYS_V2,
    },
    GLOBAL_PREMIUM_12_MONTH: {
        packageName: 'GLOBAL_PREMIUM_12_MONTH',
        quota: 2500 * 12,
        duration: 365,
        description: 'Bik Premium Annual Package',
        price: 2499,
        freeTrialDays: GLOBAL_FREE_TRIAL_DAYS_V2,
    },
    GLOBAL_VIP_12_MONTH: {
        packageName: 'GLOBAL_VIP_12_MONTH',
        quota: 7000 * 12,
        duration: 365,
        description: 'Bik VIP Annual Package',
        price: 4999,
        freeTrialDays: GLOBAL_FREE_TRIAL_DAYS_V2,
    },
    GLOBAL_ENTERPRISE_12_MONTH: {
        packageName: 'GLOBAL_ENTERPRISE_12_MONTH',
        quota: 7000 * 12,
        duration: 365,
        description: 'Manifest Enterprise Annual Package',
        price: 4999,
        freeTrialDays: GLOBAL_FREE_TRIAL_DAYS_V2,
    },
    [PACKAGENAMES.BIK_INSTAGRAM_PLAN]: {
        packageName: PACKAGENAMES.BIK_INSTAGRAM_PLAN,
        quota: 2990,
        duration: 30,
        description: 'Instagram Plan',
        price: 299,
        freeTrialDays: 14,
        overageAllowed: 598,
        waFreeCredits: 1.1,
        emailFreeCredits: 5.95,
        freeContacts: 10000,
        emailUnitCost: 0.00037,
    },
    [PACKAGENAMES.BIK_GROWTH_PLAN]: {
        packageName: PACKAGENAMES.BIK_GROWTH_PLAN,
        quota: 5990,
        duration: 30,
        description: 'Growth Plan',
        price: 599,
        freeTrialDays: 14,
        overageAllowed: 1198,
        waFreeCredits: 4.95,
        emailFreeCredits: 35.71,
        freeContacts: 100000,
        emailUnitCost: 0.00037,
        tierMapping: {
            [TIER.TIER_1]: { price: 199 },
            [TIER.TIER_2]: { price: 269 },
            [TIER.TIER_3]: { price: 469 },
            [TIER.TIER_4]: { price: 669 },
            [TIER.TIER_5]: { price: 819 },
        },
    },
    [PACKAGENAMES.BIK_BUSINESS_PLAN]: {
        packageName: PACKAGENAMES.BIK_BUSINESS_PLAN,
        quota: 7990,
        duration: 30,
        description: 'Business Plan',
        price: 799,
        freeTrialDays: 14,
        overageAllowed: 1598,
        waFreeCredits: 49.5,
        emailFreeCredits: 35.71,
        emailUnitCost: 0.00037,
        freeContacts: 2000000,
        tierMapping: {
            [TIER.TIER_1]: { price: 250 },
            [TIER.TIER_2]: { price: 339 },
            [TIER.TIER_3]: { price: 589 },
            [TIER.TIER_4]: { price: 829 },
            [TIER.TIER_5]: { price: 999 },
        },
    },
    [PACKAGENAMES.BIK_CUSTOM_PLAN]: {
        packageName: PACKAGENAMES.BIK_CUSTOM_PLAN,
        quota: 5000,
        duration: 30,
        description: 'Custom Plan',
        price: 0,
        freeTrialDays: 0,
        overageAllowed: 79900,
        waFreeCredits: 12.5,
        emailFreeCredits: 12.5,
        emailUnitCost: 0.00037,
    },
    [PACKAGENAMES.BIK_FREE_PLAN]: {
        packageName: PACKAGENAMES.BIK_FREE_PLAN,
        quota: 10,
        duration: 30,
        description: 'Free Plan',
        price: 0,
        freeTrialDays: 0,
        overageAllowed: 10,
        waFreeCredits: 0.55,
        emailFreeCredits: 0.6,
        freeContacts: 500,
        emailUnitCost: 0.00037,
    },
    [PACKAGENAMES.BIK_PLG_STARTER_PLAN]: {
        packageName: PACKAGENAMES.BIK_PLG_STARTER_PLAN,
        quota: 990,
        duration: 30,
        description: 'BIK Starter Plan',
        price: 99,
        freeTrialDays: 14,
        overageAllowed: 198,
        waFreeCredits: 1.1,
        emailFreeCredits: 5.95,
        freeContacts: 10000,
        emailUnitCost: 0.00037,
        tierMapping: {
            [TIER.TIER_1]: { price: 99 },
            [TIER.TIER_2]: { price: 169 },
            [TIER.TIER_3]: { price: 179 },
            [TIER.TIER_4]: { price: 329 },
            [TIER.TIER_5]: { price: 529 },
        },
    },
    [PACKAGENAMES.BIK_PLG_GROWTH_PLAN]: {
        packageName: PACKAGENAMES.BIK_PLG_GROWTH_PLAN,
        quota: 3990,
        duration: 30,
        description: 'BIK Growth Plan',
        price: 399,
        freeTrialDays: 14,
        overageAllowed: 798,
        waFreeCredits: 4.95,
        emailFreeCredits: 35.71,
        freeContacts: 100000,
        emailUnitCost: 0.00037,
        tierMapping: {
            [TIER.TIER_1]: { price: 199 },
            [TIER.TIER_2]: { price: 269 },
            [TIER.TIER_3]: { price: 469 },
            [TIER.TIER_4]: { price: 669 },
            [TIER.TIER_5]: { price: 819 },
        },
    },
    [PACKAGENAMES.BIK_PLG_BUSINESS_PLAN]: {
        packageName: PACKAGENAMES.BIK_PLG_BUSINESS_PLAN,
        quota: 7990,
        duration: 30,
        description: 'BIK Business Plan',
        price: 799,
        freeTrialDays: 14,
        overageAllowed: 1598,
        waFreeCredits: 49.5,
        emailFreeCredits: 35.71,
        freeContacts: 2000000,
        emailUnitCost: 0.00037,
        tierMapping: {
            [TIER.TIER_1]: { price: 250 },
            [TIER.TIER_2]: { price: 339 },
            [TIER.TIER_3]: { price: 589 },
            [TIER.TIER_4]: { price: 829 },
            [TIER.TIER_5]: { price: 999 },
        },
    },
    [PACKAGENAMES.BIK_SALES_STARTER_PLAN]: {
        packageName: PACKAGENAMES.BIK_SALES_STARTER_PLAN,
        quota: 990,
        duration: 30,
        description: 'BIK Sales Starter Plan',
        price: 99,
        freeTrialDays: 14,
        overageAllowed: 198,
        waFreeCredits: 0,
        emailFreeCredits: 0,
        freeContacts: 0,
        emailUnitCost: 0.00037,
        tierMapping: {
            [TIER.TIER_1]: { price: 99 },
            [TIER.TIER_2]: { price: 169 },
            [TIER.TIER_3]: { price: 179 },
            [TIER.TIER_4]: { price: 329 },
            [TIER.TIER_5]: { price: 529 },
        },
    },
    [PACKAGENAMES.BIK_SALES_GROWTH_PLAN]: {
        packageName: PACKAGENAMES.BIK_SALES_GROWTH_PLAN,
        quota: 3990,
        duration: 30,
        description: 'BIK Sales Growth Plan',
        price: 399,
        freeTrialDays: 14,
        overageAllowed: 798,
        waFreeCredits: 0,
        emailFreeCredits: 0,
        freeContacts: 0,
        emailUnitCost: 0.00037,
        tierMapping: {
            [TIER.TIER_1]: { price: 199 },
            [TIER.TIER_2]: { price: 269 },
            [TIER.TIER_3]: { price: 469 },
            [TIER.TIER_4]: { price: 669 },
            [TIER.TIER_5]: { price: 819 },
        },
    },
    [PACKAGENAMES.BIK_SALES_BUSINESS_PLAN]: {
        packageName: PACKAGENAMES.BIK_SALES_BUSINESS_PLAN,
        quota: 7990,
        duration: 30,
        description: 'BIK Sales Business Plan',
        price: 799,
        freeTrialDays: 14,
        overageAllowed: 1598,
        waFreeCredits: 0,
        emailFreeCredits: 0,
        freeContacts: 0,
        emailUnitCost: 0.00037,
        tierMapping: {
            [TIER.TIER_1]: { price: 250 },
            [TIER.TIER_2]: { price: 339 },
            [TIER.TIER_3]: { price: 589 },
            [TIER.TIER_4]: { price: 829 },
            [TIER.TIER_5]: { price: 999 },
        },
    },
};
exports.ExchangeRateMap = {
    'USD-INR': 83.235758,
    'INR-USD': 0.0120141,
    'GBP-INR': 101.020305081,
    'INR-GBP': 0.00990747,
    'AUD-INR': 52.606042,
    'INR-AUD': 0.0190078,
    'JPY-INR': 0.55805653,
    'INR-JPY': 1.79193,
    'INR-PKR': 3.41966,
    'PKR-INR': 0.2924269,
    'CAD-INR': 60.719681,
    'INR-CAD': 0.0164691,
    'INR-RUB': 1.19476,
    'RUB-INR': 0.83698689,
    'INR-AED': 0.0441093,
    'AED-INR': 22.670942,
    'INR-EUR': 0.011435464,
    'EUR-INR': 87.447258,
    'INR-BRL': 0.061935861,
    'BRL-INR': 16.1457,
    'USD-GBP': 0.811721,
    'USD-EUR': 0.940639,
    'USD-CAD': 1.36082,
    'USD-SGD': 1.36185,
    'USD-USD': 1,
    'USD-SAR': 3.75,
    'SAR-USD': 0.26666667,
    'KWD-USD': 3.23494,
    'USD-KWD': 0.309125,
    'QAR-USD': 0.27472527,
    'USD-QAR': 3.64,
    'AED-USD': 0.27229408,
    'USD-AED': 3.6725,
    'ZAR-USD': 0.053130272,
    'USD-ZAR': 18.8202,
    'PKR-USD': 0.0035818064,
    'USD-PKR': 279.189,
    'LKR-USD': 0.0030839229,
    'USD-LKR': 324.262,
    'TRY-USD': 0.03604935,
    'USD-TRY': 27.7395,
    'CNY-USD': 0.13756281,
    'USD-CNY': 7.26941,
    'CNH-USD': 0.13701883,
    'USD-CNH': 7.29853,
    'BRL-USD': 0.19798628,
    'USD-BRL': 5.05086,
    'KRW-USD': 0.0007471076,
    'USD-KRW': 1338.5,
    'AUD-USD': 0.6409892,
    'USD-AUD': 1.56009,
    'JPY-USD': 0.0067046544,
    'USD-JPY': 149.15,
    'CAD-USD': 0.7348507,
    'GBP-USD': 1.2319473,
    'EUR-USD': 1.0631068,
    'SGD-USD': 0.73429505,
};
